'use es6';

import PropTypes from 'prop-types';
import pipe from 'transmute/pipe';
export const oneOfObjectKeys = pipe(Object.keys, PropTypes.oneOf);
export const oneOfObjectValues = pipe(Object.values, PropTypes.oneOf);